// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CalendarDay__today{background:#e4e7e7}`, "",{"version":3,"sources":["webpack://./resources/app/core/components/form/form_date.scss"],"names":[],"mappings":"AAAA,oBACE,kBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
